// FilterChip.jsx (o inline en el mismo archivo si preferís no crear otro componente)
import { Chip } from '@mui/material';
import { tokens } from '../../theme/tokens';

const FilterChip = ({ label, active, onClick }) => (
  <Chip
    label={label}
    onClick={onClick}
    sx={{
      borderRadius: `${tokens.radius.md}px`,
      fontWeight: 600,
      fontSize: 13,
      px: 0.5,
      border: `1px solid ${active ? 'rgba(108,114,255,.4)' : tokens.colors.line}`,
      backgroundImage: active ? tokens.gradient.soft : 'none',
      backgroundColor: active ? 'transparent' : tokens.colors.panel,
      color: active ? tokens.colors.txt : tokens.colors.muted,
      transition: 'all .15s',
      '&:hover': {
        color: tokens.colors.txt,
        borderColor: active ? 'rgba(108,114,255,.4)' : tokens.colors.line2,
        backgroundColor: active ? 'transparent' : tokens.colors.panel,
      },
    }}
  />
);

export default FilterChip;